import React from 'react';
import { Phone, MessageCircle, Car, MapPin } from 'lucide-react';

export const MobileStickyBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-lg">
      <div className="grid grid-cols-4 divide-x divide-gray-200">
        <a
          href="tel:+4939163577134"
          className="flex flex-col items-center justify-center py-3 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-colors"
        >
          <Phone className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Anrufen</span>
        </a>
        
        <a
          href="https://wa.me/4939163577134?text=Hallo,%20ich%20interessiere%20mich%20für%20ein%20Fahrzeug"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 text-gray-700 hover:text-green-600 hover:bg-green-50 transition-colors"
        >
          <MessageCircle className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">WhatsApp</span>
        </a>
        
        <a
          href="/fahrzeugbestand.html"
          className="flex flex-col items-center justify-center py-3 text-gray-700 hover:text-red-600 hover:bg-red-50 transition-colors"
        >
          <Car className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Bestand</span>
        </a>
        
        <a
          href="https://www.google.com/maps/dir//Autohaus+Wilke+Magdeburg"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors"
        >
          <MapPin className="w-5 h-5 mb-1" />
          <span className="text-xs font-medium">Route</span>
        </a>
      </div>
    </div>
  );
};
